var $bafcc9870f83af97$exports = {};
$bafcc9870f83af97$exports = {
    "collectionLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`
};


export {$bafcc9870f83af97$exports as default};
//# sourceMappingURL=ru-RU.module.js.map
